import { SkillStatsResponse } from '../types';
import api from './api';

/**
 * スキル統計データを取得
 * @param employeeId - 従業員ID
 * @returns スキル統計データ
 */
export async function fetchSkillStats(employeeId: string): Promise<SkillStatsResponse> {
  const response = await api.get<SkillStatsResponse>(`/skills/stats/${employeeId}`);
  return response.data;
}
